export const VALIDATORS = {
  IS_DATE: 'isDate',
  IS_OVER_LIMIT: 'isOverLimit',
  IS_UNDER_LIMIT: 'isUnderLimit',
  IS_EMAIL: 'isEmail',
  IS_REQUIRED: 'required',
  MIN_LENGTH: 'minStringLength',
  PASSWORD_MATCH: 'isPasswordMatch',
  EMAIL_MATCH: 'isEmailMatch',
  IS_PASSWORD_LENGTH_OK: 'isPasswordLengthOk',
  IS_PHONE_NUMBER: 'isPhoneNumber',
  IS_ADULT: 'isAdult',
  IS_SIRET: 'isSiret',
  ONLY_NUMBERS: 'onlyNumbers',
  ONLY_LATIN_CHARS: 'onlyLatinChars'
};
